import { Component as ReactComponent } from 'react'
import _ from 'lodash'

import { envSetting } from '@vzmi/ec_file_uploader_sdk'
import { getIsAnyFileUploading, filterFileListByError } from '../../../../lib/uploaderUtil'
import { ANT_UPLOAD_STATUS } from '../../../../constants/globalTypes'
import uuidv1 from 'uuid/v1'

const AWS_CONFIG = _.get(envSetting, `${_.get(global, 'window.EC_APP_ENV')}.aws`, {})

export default function withUploadModule (Component) {
  // eslint-disable-next-line
  class UploadModuleHoc extends ReactComponent {
    state = {
      isAllFileUploaded: false,
      fileList: []
    }

    setUploaderOptions = props => {
      this.setState({
        uploaderOptions: Object.assign({
          /** override S3Upload internal methods/options */
          getWssId: this.props.getWssId,
          getCredentials: this.props.getCredentials,
          contentDisposition: 'auto'
        }, props.upload)
      })
    }

    // Setup state files by props
    setDefaultFileList = (files = []) => {
      let localFiles = !_.isEmpty(files) ? (Array.isArray(files) ? files : [files]) : null
      if (_.isEmpty(localFiles)) {
        return
      }
      localFiles = _.compact(_.map(localFiles, (file) => {
        if (_.isEmpty(file) || !file.url) {
          return null
        }
        return ({
          ...file,
          uploaded: file.status === ANT_UPLOAD_STATUS.DONE || true,
          uid: file.uid || uuidv1(),
          status: file.status || ANT_UPLOAD_STATUS.DONE
        })
      }))
      !_.isEmpty(localFiles) && this.updateStateFileList(localFiles)
    }

    getS3Object = (s3FileInfo, file) => {
      return this.props.transformS3Object(s3FileInfo, file)
    }

    // replace file in the state
    updateStateFile = (file, triggerOnFinish) => {
      const stateFiles = this.state.fileList
      const omittedFile = _.omit(file, ['originFileObj'])
      const files = Array.isArray(file) ? omittedFile : [omittedFile]
      const unionFiles = _.map(_.merge(
        _.mapKeys(stateFiles, k => k.uid),
        _.mapKeys(files, k => k.uid)
      ))
      this.updateStateFileList(unionFiles, triggerOnFinish)
    }

    // replace the file list with input
    updateStateFileList = (fileList, triggerOnFinish) => {
      this.setState((state) => ({
        // 重啓上傳時將錯誤的 file 從 list 中移除
        fileList: (state.isAllFileUploaded && !_.isEqual(fileList, state.fileList))
          ? filterFileListByError(fileList)
          : fileList
      }), state => {
        this.handleAllFileUploaded(this.state.fileList, triggerOnFinish)
      })
    }

    removeFile = (file = {}) => {
      const fileList = _.filter(this.state.fileList, (localFile) => file.uid !== localFile.uid)
      this.updateStateFileList(fileList, true)
    }

    updateFileList = (fileList = []) => {
      this.updateStateFileList(fileList, true)
    }

    // send out state file to parent
    handleFinish = (files) => {
      this.props.onFinish && this.props.onFinish(files)
    }

    handleChange = (info) => {
      const { file } = info
      const fileUploaded = file.status === 'done'
      const response = _.get(file, 'response', {})
      const pickedObj = _.pick(response, ['expiredTs', 'url'])
      const omittedFile = _.omit(file, ['originFileObj'])
      const returnFile = {
        ...omittedFile,
        uid: file.uid,
        uploaded: fileUploaded,
        ...pickedObj
      }
      this.updateStateFile(returnFile, fileUploaded)
    }

    handleAllFileUploaded = (fileList, triggerOnFinish) => {
      if (!getIsAnyFileUploading(fileList)) {
        this.setState(() => ({
          isAllFileUploaded: true
        }), () => triggerOnFinish && this.handleFinish(fileList))
        return
      }
      this.props.onUpdateFile && this.props.onUpdateFile(fileList)
      this.setState(() => ({
        isAllFileUploaded: false
      }))
    }

    getDefaultS3Options = ({ onSuccess, onProgress, file }) => {
      return {
        files: [file],
        config: AWS_CONFIG,
        ...this.state.uploaderOptions,
        onError: (error, localFile) => {
          const finalFile = { ...localFile, status: ANT_UPLOAD_STATUS.ERROR, error }
          this.updateStateFile(finalFile)

          return finalFile
        },
        onProgress: (percent, state, file) => onProgress({ percent }),
        onFinishS3Put: (...props) => {
          return this.getS3Object(...props)
            .then((s3Object) => {
              onSuccess(s3Object)
            })
        }
      }
    }

    render () {
      const { ...props } = this.props
      const passOnMethods = _.pick(this, ['getDefaultS3Options', 'handleChange', 'handleFinish', 'setUploaderOptions', 'updateFileList', 'removeFile', 'updateStateFile', 'getS3Object', 'setDefaultFileList'])
      return (
        <Component
          {...props}
          {...passOnMethods}
          fileList={this.state.fileList}
          isAllFileUploaded={this.state.isAllFileUploaded}
        />
      )
    }
  }

  return UploadModuleHoc
}
